import { render, staticRenderFns } from "./ui-guide.vue?vue&type=template&id=5dfde2a6&"
import script from "./ui-guide.vue?vue&type=script&lang=js&"
export * from "./ui-guide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports